import { Section } from './../../models/manage-forms.interface';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { CharCountDirective } from 'src/app/shared/directives/char-count.directive';
import { AuditlogEventType, AuditlogId, AuditLogInterfaceName } from 'src/app/shared/enumerations/auditlog.enumeration';
import { PropertyDataType, SortHelper } from 'src/app/shared/helpers/sort.helper';
import { Question, SectionQuestion, WordMark } from 'src/app/shared/models/shared.inerface';
import { AuditlogService } from 'src/app/shared/services/auditlog.service';
import { Form, Submission, SubmissionItem } from '../../models/manage-forms.interface';
import { FormService } from '../../services/formservice';
import { ConstantsService } from 'src/app/shared/services/constants.service';
import { Constants } from 'src/app/shared/constants';
import { WordMarkService } from 'src/app/shared/services/wordmarkservice';


@Component({
  selector: 'app-view-form',
  templateUrl: './view-form.component.html',
  styleUrls: ['./view-form.component.css'],
  providers: [ConfirmationService,FormService]
})
export class ViewFormComponent implements OnInit {
  @Input()
  form: Form;
  isFormLoaded = false;
  isFormView = false;
  isFormExpOrInactive = false;
  isHcaptcha = false;
  list: SelectItem[] = [];
  isInternal: boolean;
  saveForLaterModal: boolean;
  savedFormEmailModal: boolean;
  email: SelectItem[];
  emailAddress: string;
  savedFormSubmission: Submission = {};
  emailError: boolean;
  submission: Submission = {};
  subItemList: SubmissionItem[] = [];
  submissionItem: SubmissionItem = {};
  saveSuccess = false;
  saveForSubmitModal = false;
  emailCopyToSubmitter: string;
  formUrl: string;
  maxYear: string;
  minYear: string;
  minDate: Date;
  maxDate: Date;

  @ViewChild(CharCountDirective) private charCountDirective: CharCountDirective;
  showSave = false;

  allWorkMarks: WordMark[] = [];

  constructor(
    public auditlogService: AuditlogService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private formService: FormService,
    private confirmationService: ConfirmationService,
    private constService: ConstantsService,
    private wmService: WordMarkService,) {
    this.email = [
      { label: "- Select -", value: null },
      { label: "Email 1", value: "Email 1" },
      { label: "Email 2", value: "Email 2" },
      { label: "Email 3", value: "Email 3" },
    ];
  }

  ngOnInit(): void {

    this.route.queryParams.subscribe((params: Params) => {
      const id = params['formId'];
      const internal = params['internal'];
      if (id && internal) {
        this.logView(id);
        this.isFormView = false;
        this.isInternal = (internal === 'Yes');
        const sid = params['sid'];
        const saveKey = params['k'];
        this.loadForm(id, sid, saveKey);
      } else {
        // console.log(this.form);
        this.logView(this.form.id);
        this.isFormView = true;
        this.isFormLoaded = true;
      }
    });
    this.constService.getProperties().subscribe(props=>{
      this.maxYear = props.find(prop=>prop.name==='CALENDAR_MAX_YEAR')?.value;
      this.minYear = props.find(prop=>prop.name==='CALENDAR_MIN_YEAR')?.value;
      this.minDate = new Date(parseInt(this.minYear),11,31,23);
      this.maxDate = new Date(parseInt(this.maxYear),11,31,23);
    })
  }


  setFormDateQuestionMinMaxDate(form:Form):Form{
    console.log('------------ before -----------------' , form);
    form.sections?.forEach( section => {
      section.questions?.forEach( sectionQuestion =>{
         console.log('------------ question.type -----------------' , sectionQuestion.question?.type);
        if( sectionQuestion.question?.type === 'DATE') {
            console.log('----------------------- setFormDateQuestionMinMaxDate -----------  ') ;
             sectionQuestion.question.minDate =  this.getDateRestriction(sectionQuestion)==='2'?new Date():this.minDate;
             sectionQuestion.question.maxDate =  this.getDateRestriction(sectionQuestion)==='1'?new Date():this.maxDate;
        }
      })
    })
    console.log('------------ after -----------------', form);
    return form;
  }

  loadForm(id: string, sid: string, saveKey: string) {

    this.wmService.getData().subscribe(data => {

      this.allWorkMarks = data.filter(item => item.status === 'Active');
      this.formService.getFormViewById(id).subscribe(form => {

        this.form = this.setFormDateQuestionMinMaxDate(form);

        if(this.form.logoImage){
          this.form.cdnLogoUrldn = this.allWorkMarks.find(wm => wm.id === this.form.logoImage).cdnLogoUrl;
        }
        this.formUrl =  this.formService.getFormUrl(this.form);
        this.sortFormOrder();
        console.log("Form Object ::: ", this.form);

        this.isFormExpOrInactive = (this.form.inactive || (this.form.expires && new Date(this.form.expires) < new Date()));
        this.form.displayRequireValidation = this.form.requireValidation ? 'Yes' : 'No';

        if (sid && saveKey && !this.isFormExpOrInactive) {
          this.loadSavedForm(sid, saveKey);
        }
        this.isFormLoaded = true;
      }, error => {
        console.log(error);
        this.confirm();
      });
  });
  }


  sortFormOrder(): void {
    SortHelper.sortArrayByPropertyValue(
      this.form?.sections,
      'order',
      PropertyDataType.NUMBER
    )
    this.form?.sections?.forEach(section => {
      SortHelper.sortArrayByPropertyValue(
        section.questions,
        'order',
        PropertyDataType.NUMBER
      )
    });
  }



  loadSavedForm(sid: string, saveKey: string) {
    this.formService.getSubmissionById(sid).subscribe((data: Submission) => {
      console.log(data);
      this.savedFormSubmission = data;
      if (this.savedFormSubmission.saveKey === saveKey) {
        this.savedFormEmailModal = true;
      } else {
        const confirmMessage = 'The form has been submitted and cannot be modified.';
        this.savedFormSubmission = {};
        this.confirmSaveForLater(confirmMessage);
      }

    });
  }

  getOptionList(question: Question) {
    this.list = [];
    this.list.push({
      value: null,
      label: "-Select-"
    })
    question.answers.forEach((answer) => {
      this.list.push({
        value: answer.id,
        label: answer.answer
      })
    });
  //  return this.list;
  }

  logView(id: string) {
    this.auditlogService.logEventByParams(
      AuditlogId.VIEW_FORM,
      AuditlogEventType.VIEW,
      AuditLogInterfaceName.VIEW_FORM,
      id
    );
  }

  isQsImageExist(question: Question): boolean {
    return false;
  }
  getImage(question: Question): any {
    let objectURL = 'data:image/png;base64,' + question.files[0].file;
    return this.sanitizer.bypassSecurityTrustUrl(objectURL);
  }

  isFormValid(): boolean {
    let returnVal = true;
    if (((this.isFormView) || (this.isFormExpOrInactive)) || (this.form.displayRequireValidation === 'Yes' && !this.isHcaptcha)) {
      returnVal = false;
      return returnVal;
    }
    this.form.sections.forEach(section => {
      section.questions.forEach(question => {
        if (question.required && (!question.question.selAnswer || question.question.selAnswer.length == 0)) {
          returnVal = false;
          return returnVal;
        }
      })
    });
    return returnVal;
  }

  isOneFieldEntered() {
    let returnVal = false;
    if (((this.isFormView) || (this.isFormExpOrInactive)) || (this.form.displayRequireValidation === 'Yes' && !this.isHcaptcha)) {
      return returnVal;
    }
    this.form.sections.forEach(section => {
      section.questions.forEach(question => {
        if (question.question.selAnswer || question.question.selAnswer?.length > 0) {
          returnVal = true;
          return returnVal;
        }
      })
    });
    return returnVal;
  }

  clear() {
    this.form.sections.forEach(section => {
      section.questions.forEach(question => {
        question.question.selAnswer = '';
      })
    });
    this.charCountDirective?.ngOnInit();
  }


  confirm() {
    const confirmMessage = 'The URL to your form is not valid or your form no longer exists. Click OK to continue to the current version of this form';
    const acceptFunction = () => { alert('TODO:display current version of the form') }
    this.confirmationService.confirm({
      //key: this.getConfirmDialogKey(centerMsg),
      icon: 'confirm-none',
      header: '',
      acceptLabel: 'OK',
      rejectLabel: 'Cancel',
      message: `${confirmMessage}`,
      acceptButtonStyleClass: 'confirm-none p-button-rounded p-button-secondary',
      rejectButtonStyleClass: 'confirm-none p-button-rounded p-button-secondary p-button-outlined',
      accept: () => {
        acceptFunction();
      },
      reject: () => {
        this.confirmationService.close();
      },
    });
  }

  confirmSaveForLater(confirmMessage: string) {
    const acceptFunction = () => {
      window.close();
    }
    this.confirmationService.confirm({
      //key: this.getConfirmDialogKey(centerMsg),
      icon: 'confirm-none',
      header: '',
      acceptLabel: 'OK',
      message: `${confirmMessage}`,
      acceptButtonStyleClass: 'confirm-none p-button-rounded p-button-secondary',
      rejectButtonStyleClass: 'confirm-none p-button-rounded p-button-secondary p-button-outlined',
      accept: () => {
        acceptFunction();
      },
      rejectVisible: false
    });
  }

  sendSubmitEmail() {
    this.saveForm();
  }

  confirmSubmit() {
    const confirmMessage = 'Are you sure you want to submit this form? Forms cannot be edited once they have been submitted.';
    const acceptFunction = () => {
      if (this.form.sendCopyToSubmitter) {
        this.saveForSubmitModal = true;
      } else {
        this.saveForSubmitModal = false;
        this.saveForm();
      }
      //this.saveSuccess = true;
    }
    console.log("form from confirmSubmit ===", this.form);
    this.confirmationService.confirm({
      //key: this.getConfirmDialogKey(centerMsg),
      icon: 'confirm-none',
      header: '',
      acceptLabel: 'Yes',
      rejectLabel: 'No',
      message: `${confirmMessage}`,
      acceptButtonStyleClass: 'confirm-none p-button-rounded p-button-secondary',
      rejectButtonStyleClass: 'confirm-none p-button-rounded p-button-secondary p-button-outlined',
      accept: () => {
        acceptFunction();
      },
      reject: () => {
        this.confirmationService.close();
      },
    });
  }

  public hcaptcha(token: string | null) {
    this.isHcaptcha = true;
  }

  isValidateEmail(): boolean {
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(this.emailAddress).toLowerCase());
  }

  isValidateSubmitEmail(): boolean {
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(this.emailCopyToSubmitter).toLowerCase());
  }


  loadSavedFormByEmail() {
    if (this.emailAddress.toUpperCase() === this.savedFormSubmission.email.toUpperCase()) { // igore case when comparing emails
      const submissionItems = this.savedFormSubmission.submissionItems;
      // console.log(submissionItems);
      submissionItems.forEach(submissionItem => {
        const section = this.form.sections.find(s => s.id === submissionItem.sectionID);
        //  console.log(section);
        const sectionQuestion = section.questions.find(q => q.question.id === submissionItem.questionID)
        if (sectionQuestion.question.type === 'CHECKBOX') {
          sectionQuestion.question.selAnswer = submissionItem.answer.split(',');
        } else if (sectionQuestion.question.type === 'DATE') {
          sectionQuestion.question.selAnswer = new Date(submissionItem.answer);
        } else {
          sectionQuestion.question.selAnswer = submissionItem.answer;
        }


        //  console.log(sectionQuestion);
      })
      this.savedFormEmailModal = false;
    } else {
      this.emailError = true;
    }
  }

  saveForLater() {
    this.submission.url = this.formService.getFormUrl(this.form);
    console.log(this.form)
    this.saveForm(this.emailAddress);
  }

  saveForm(email?: string) {
    this.submission.id = this.savedFormSubmission.id;
    this.submission.formId = this.form.id;
    this.submission.email = email;
    if (this.form.sendCopyToSubmitter && this.emailCopyToSubmitter) {
      this.submission.emailToSubmitter = this.emailCopyToSubmitter
    }
    const submissionItems: SubmissionItem[] = [];
    this.form.sections.forEach(section => {
      section.questions.forEach(question => {
        if (question.question.selAnswer) {
          const submissionItem: SubmissionItem = {};
          submissionItem.sectionID = section.id;
          submissionItem.questionID = question.question.id
          if (question.question.type == 'DATE') {
            submissionItem.answer = this.convertDate(question.question.selAnswer);
            console.log("submissionItem.answer===", submissionItem.answer);
          } else {
            submissionItem.answer = String(question.question.selAnswer);
          }
          submissionItem.questionOrder = question.order;
          submissionItems.push(submissionItem);
        }
      });
    });
    this.submission.submissionItems = submissionItems;
    console.log(this.submission);
    this.formService.saveSubmission(this.submission).subscribe((data: any) => {
      if (this.emailAddress) {
        this.emailAddress = '';
        this.logAuditSaveForLater(data.id)
        this.saveForLaterModal = false;
        const confirmMessage = 'The form has been saved and an email has been sent to you. Follow instructions in the email to return to the form later.';
        this.confirmSaveForLater(confirmMessage);
      }
      this.emailCopyToSubmitter = null;
      this.saveForSubmitModal = false;
      this.saveSuccess = true;
    });
  }

  private convertDate(dateC: string) {
    var date = new Date(dateC),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
      return [  mnth, day, date.getFullYear()].join("/");
  }
  private logAuditSaveForLater(id: string) {
    this.auditlogService.logEventByParams(
      AuditlogId.VIEW_FORM_SAVE_FOR_LATER,
      AuditlogEventType.SAVE_FOR_LATER,
      AuditLogInterfaceName.MANAGE_FORMS,
      id,

    );
  }


  canEnterDateManually(question:SectionQuestion) :boolean {
   return question.question?.properties.find(p => p.name ===  'EnterDateManually').value !== '1'
  }

  getDateRestriction(question:SectionQuestion) :string {
    return question.question?.properties.find(p => p.name ===  Constants.DATE_RESTRICTION).value;
   }

  getYearRange(question:SectionQuestion) :string {
    const dateRestriction = this.getDateRestriction(question);
    if(dateRestriction =='0'){
      return this.minYear+':'+this.maxYear;
    } else if(dateRestriction =='1'){
      //this.maxDate = new Date();
      return this.minYear+':'+new Date().getFullYear();
    } else {
      //this.minDate = new Date();
      return new Date().getFullYear()+':'+this.maxYear;
    }
  }


}
